import { ChangeDetectionStrategy, Component, DestroyRef, effect, inject, input, signal } from '@angular/core';
import { DatePipe } from '@angular/common';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Subject, debounceTime } from 'rxjs';
import { DriversSalaryV2StateService } from '../_services/drivers-salary-v2.state.service';

@Component({
	selector: 'app-salary-tourism-event-row',
	standalone: true,
	imports: [
		DatePipe,
		FormsModule,
		RouterLink,
		MatCheckboxModule,
		MatFormFieldModule,
		MatInputModule,
		MatTooltipModule,
	],
	templateUrl: './salary-tourism-event-row.component.html',
	styleUrl: './salary-tourism-event-row.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SalaryTourismEventRowComponent {
	readonly eventId = input.required<string>();
	readonly dateFrom = input.required<string>();
	readonly dateTo = input.required<string>();
	readonly excluded = input.required<boolean>();
	readonly comment = input<string | null>(null);
	readonly disabled = input<boolean>(false);

	readonly commentValue = signal<string>('');

	private readonly state = inject(DriversSalaryV2StateService);
	private readonly destroyRef = inject(DestroyRef);
	private readonly commentInput = new Subject<string>();

	constructor() {
		effect(() => this.commentValue.set(this.comment() ?? ''), { allowSignalWrites: true });

		this.commentInput.pipe(debounceTime(500), takeUntilDestroyed(this.destroyRef)).subscribe((value) => {
			this.state.setEventExclusion(this.eventId(), this.excluded(), this.normalize(value));
		});
	}

	onCountedChange(counted: boolean): void {
		this.state.setEventExclusion(this.eventId(), !counted, this.normalize(this.commentValue()));
	}

	onCommentInput(value: string): void {
		this.commentValue.set(value);
		this.commentInput.next(value);
	}

	private normalize(value: string): string | null {
		const trimmed = value.trim();
		return trimmed === '' ? null : trimmed;
	}
}
